<template>
	<compWrapper theme="primary" title="基本信息">
		<compFormEdit
			:formdata="getBase"
			:labelWidth="120"
			class="margin-layout width-60per"
			col="1"
			ref="formbase"
			v-model="formData"
		/>
		<vButtonGroup class="text-right">
			<vButton @click="submit" class="margin-right-10" theme="primary">确认</vButton>
			<vButton @click="close">返回</vButton>
		</vButtonGroup>
		<div class="code" style="padding-left:100px;background:#d1d1d1;">
			<pre ref="responseDataContent"></pre>
		</div>
		<compModal v-model="operate.show" v-bind="operate" @on-close="operate.show=false">
			<component
				v-if="operate.component"
				:is="operate.component"
				v-bind="operate.props"
				@on-close="operate.show=false"
				v-on="operate.on"
			/>
		</compModal>
		<vLoading loading size="large" transfer v-if="loading"></vLoading>
	</compWrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import compUserlist from './userlist';
import mixin from '../mixin'
import { HttpBizeventGen } from '../../../service/notice'

export default {
	components: {
		compUserlist
	},
	mixins: [mixin],
	data() {
		return {
			loading: false,
			formData: {
				userName: [],
				// evtpId: 1
			},
			operate: {
				show: false,
			}
		}
	},
	created() {
		this.formData = {
			userName: [this.getAuthUser.name],
			evtpId: 1,
			orgId: this.getAuthUser.orgId,
			uid: this.getAuthUser.id
		}
	},

	methods: {
        rowTrimWebhookPrefix (webhookUrl) {
            if (webhookUrl && webhookUrl.indexOf('=') !== -1 && (webhookUrl.indexOf('=') != webhookUrl.length - 1)) {
                this.formData.gkey = webhookUrl.substring(webhookUrl.indexOf('=') + 1)
            } else {
                this.formData.gkey = webhookUrl
            }
        },
		//保存数据
		async submit() {
			const valid = await this.$refs.formbase.validate()
			if (!valid) return
			this.loading = true
			const formData = {
				...this.formData,
			}
			await HttpBizeventGen(formData).then(this.parseResponse).catch(err => {
				this.$VMessage.error(err.message)
				this.loading = false
			})
		},
		parseResponse(data) {
			console.log('parseResponse', data)
			const { responseDataContent } = this.$refs;
			responseDataContent.innerHTML = JSON.stringify(data, null, 2)
			this.loading = false
            this.$VMessage.success(data.message)
            this.close()
		},
		close() {
			this.$router.push({
				name: 'noticeRules'
			})
		},
		handleUserModal() {
			this.operate = {
				title: '用户',
				show: true,
				width: 'large',
				component: "compUserlist",
				props: {
					initFormData: {
						'ids': this.formData.uid
					}
				},
				on: {
					'on-data': (row) => {
						this.operate = {};
						this.formData = { ...this.formData, uid: row.id, userName: [row.name] };
					}
				},
				showFooter: false,
			}
		},
	},
	computed: {
		...mapGetters(['isSuper', 'getAuthUser']),
		...mapGetters('dictionary', ['getProductList', 'getAccountList', 'getWarehouseList', 'getOrgList']),
		getBase() {
			return [
				// {
				// 	label: "模板名称",
				// 	key: "title",
				// },
				{
					label: '事件类型',
					key: 'evtpId',
					tag: 'vSelect',
					options: this.getNoticeEevntTypes
				},
				{
					label: "指定人员",
					key: "userName",
					children: (h) => {
						return <vIcon
							type="search"
							slot="suffix"
							size="18"
							class="margin-right-5"
							nativeOnClick={this.handleUserModal}
						/>
					},
					props: {
						readonly: true,
						multiple: true,
					},
					required: false,
				},
				{
					label: '钉钉token',
					key: 'gkey',
					tag: 'vInput',
					clear: true,
					required: false,
                    formItem: {
                        tip: '<div class=color-info>如果通知方式是钉钉，此栏位必填。请填写钉钉群组的webhook的token部分</div>'
                    },
                    on: {
                        'on-blur': this.rowTrimWebhookPrefix
                    }
				},
				{
					label: "所属组织",
					key: "orgId",
					tag: "vSelect",
					options: this.getOrgList,
					props: {
						filterable: true,
					},
					required: true,
				},
				{
					label: '所属项目',
					key: 'lineId',
					tag: 'vSelect',
					options: this.getProductList,
					props: {
						filterable: true,
					},
					required: false,
				},
				{
					label: '所属渠道账号',
					key: 'accountId',
					tag: 'vSelect',
					options: this.getAccountList,
					props: {
						filterable: true,
					},
					required: false,
				},
				{
					label: '所属组织仓库',
					key: 'orgwarehouseId',
					tag: 'vSelect',
					options: this.getWarehouseList,
					props: {
						filterable: true,
					},
					required: false,
				},
				{
					label: '平台单据编号',
					key: 'idLabel',
					tag: 'vInput',
					required: false,
				},
				{
					label: '来源单据编号',
					key: 'srcLabel',
					tag: 'vInput',
					required: false,
				},
				{
					label: '事件说明',
					key: 'title',
					tag: 'vInput',
					required: false,
				},
				{
					label: '事件等级',
					key: 'level',
					tag: 'vSelect',
					options: this.getAppLevel,
					required: false,
				}
			]
		}
	}
}
</script>


